<script>
import { assetURL, baseURL } from '../../utils/url';

export default {
    props: {
        description: {
            default() {
                return '';
            },
        },
        banner: {
            default() {
                return '';
            },
        },
        heading: {
            default() {
                return '';
            },
        },
    },
};
</script>
<template>
    <div class="tw-w-full">
        <div
            class="tw-w-full tw-h-[360px] lg:tw-h-[480px] xxl:tw-h-[600px] tw-bg-cover tw-bg-no-repeat tw-bg-center tw-mb-[50px]"
            :style="{ 'background-image': 'url(' + this.$props.banner + ')' }"
        ></div>
        <div class="tw-px-4 lg:tw-px-24 xxl:tw-px-28 tw-space-y-5">
            <h1
                class="tw-text-darkGreen tw-leading-10 tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-5xl tw-font-extrabold"
            >
                {{ this.$props.heading }}
            </h1>
            <p
                class="tw-text-black tw-font-medium tw-text-[20px] lg:tw-w-[613px] xxl:tw-w-[901px]"
            >
                {{ this.$props.description }}
            </p>
        </div>
    </div>
</template>
